var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsSave = function SvgInterfaceActionsSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3c-1.094 0-2 .906-2 2v14c0 1.094.906 2 2 2h14c1.094 0 2-.906 2-2V7l-4-4zm0 2h11.172L19 7.828V19H5zm2 2v3h8V7zm4.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
  })));
};
export default SvgInterfaceActionsSave;